import { useState, useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { hasRole } from '@/services/data/roles';

export function useIsAdmin() {
  const { userId } = useAuthStore();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setIsAdmin(false);
      setIsLoading(false);
      return;
    }

    const checkAdminRole = async () => {
      setIsLoading(true);
      // Check for both admin and super_admin roles
      const [adminResult, superAdminResult] = await Promise.all([
        hasRole(userId, 'admin'),
        hasRole(userId, 'super_admin'),
      ]);
      const hasAdminAccess = 
        (adminResult.success && adminResult.data) || 
        (superAdminResult.success && superAdminResult.data);
      setIsAdmin(hasAdminAccess);
      setIsLoading(false);
    };

    checkAdminRole();
  }, [userId]);

  return { isAdmin, isLoading };
}
